export default class Breadcrumb {

    static initializeEvents() {
        const breadcrumb = document.querySelector('.breadcrumb');
        if (breadcrumb) {
            const breadcrumbButton = breadcrumb.querySelector('.breadcrumb-button');
            const breadcrumbCollapse = breadcrumb.querySelector('.breadcrumb-collapse');

            if (breadcrumbButton && breadcrumbCollapse) {
                breadcrumbButton.addEventListener('click', event => {
                    event.preventDefault();

                    breadcrumbButton.setAttribute('aria-expanded', 'true');
                    breadcrumbButton.classList.add('hidden');
                    breadcrumbCollapse.classList.remove('hidden', 'block-md');
                });
            }
        }
    }

}